import { render, staticRenderFns } from "./kode_provinsi.vue?vue&type=template&id=e37340be&"
import script from "./kode_provinsi.vue?vue&type=script&lang=js&"
export * from "./kode_provinsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports